const charLengths = ['20', '10', '5', '4', '3', '2'];
const relativeLengths = ['full', 'three-quarters', 'two-thirds', 'one-half', 'one-third', 'one-quarter'];

function getWidthClass (width) {
    if (charLengths.indexOf(width) > -1) {
        return 'govuk-input--width-' + width;
    } else if (relativeLengths.indexOf(width) > -1) {
        return 'govuk-!-width-' + width;
    }
    return '';
}

export { charLengths, relativeLengths, getWidthClass };
